module.exports = __webpack_public_path__ + "img/donwloadAnd.b99ce82d.png";